export const DEFAULT_FONT_SIZE = '14px';
export const DEFAULT_FONT_FAMILY = 'Volte';

interface ProcessStage {
  id: number;
  name: string;
  path: string;
}

export const PROCESS_STAGES: ProcessStage[] = [
  {
    id: 1,
    name: 'Upload & Data Processing',
    path: '/wave-upload',
  },
  {
    id: 2,
    name: 'Meta Processing',
    path: '/meta-processing',
  },
  {
    id: 3,
    name: 'Publish to QA',
    path: '/publish-qa',
  },
];

export const FILE_UPLOAD_STATUS = {
  PENDING: 'pending',
  UPLOADING: 'uploading',
  SUCCESS: 'success',
  ERROR: 'error',
} as const;

// State of one task in the StepProgress checklist.
export const STEP_PROGRESS_STATE = {
  UPCOMING: 'upcoming',
  ACTIVE: 'active',
  RUNNING: 'running',
  COMPLETE: 'complete',
  ERROR: 'error',
} as const;

export type TaskState = (typeof STEP_PROGRESS_STATE)[keyof typeof STEP_PROGRESS_STATE];
